export default __webpack_public_path__ + "static/media/The_Nest_large_14.eb974275.jpg";